<template>
  <div class="app">
    <xmHeader :activeIndex="1"></xmHeader>
    <main>
      <div class="banner relative">
        <div class="banner-bg2"></div>
        <div class="banner-bg1"></div>
        <div class="text-container fade-in-down">
          <div class="text-container-content w-1440 px-88">
            <span class="text">关于我们</span>
          </div>
        </div>
        <div class="w-1440 px-88 banner-img">
          <img class="md:hidden" src="./assets/banner-img.png" alt="" />
          <img
            class="hidden md:block sm:!hidden"
            src="./assets/banner-img-md.png"
            alt=""
          />
          <img
            class="hidden sm:block"
            src="./assets/banner-img-sm.png"
            alt=""
          />
        </div>
      </div>
      <sonNav :sonNavData="sonNavData" ref="sonNav"></sonNav>
      <section
        class="w-1440 px-88 flex h-[724px] relative sm:block sm:!h-[638px]"
        id="aboutIntro"
      >
        <div class="about-bg fade-in-up"></div>
        <p class="section-title pt-80 flex-1 fade-in-up">关于小迈</p>
        <div
          class="about pt-80 flex-1 ml-[170px] md:ml-[-50px] sm:!px-88 sm:!ml-0 sm:!pt-[4px]"
        >
          <p class="section-subTitle mb-[72px] sm:!mb-[28px] fade-in-up">
            经过十一年的发展，小迈已经成为国内APP开发孵化运营的领导者，近三年开发者累计营收54<span
              class="font-medium"
              >亿+</span
            >元
          </p>
          <div class="text-content sm:!flex flex-col fade-in-up">
            <div
              v-for="item in aboutIntroData"
              :key="item.des"
              class="info-content sm:!mb-[24px]"
            >
              <p class="num-content">
                <span class="num sm:!text-[48px]">{{ item.num }}</span>
                <span class="unit sm:!text-[14px]">{{ item.unit }}</span>
              </p>
              <div class="des sm:!text-[12px]">{{ item.des }}</div>
            </div>
          </div>
        </div>
      </section>
      <section class="vision sm:hidden" id="aboutVisoin">
        <div class="w-1440 px-88 relative h-full">
          <p class="section-title pt-80 fade-in-up">愿景与使命</p>
          <div class="flex">
            <div
              class="flex vision-content vision-content1 h-[300px] md:!pl-0 fade-in-up"
            >
              <div class="line-container">
                <div class="point"></div>
                <div class="line"></div>
              </div>
              <div class="vision-text">
                <p class="title">我们的愿景</p>
                <p>中国领先的开发者孵化运营平台</p>
              </div>
            </div>
            <div
              class="flex vision-content vision-content2 h-[431px] fade-in-up"
            >
              <div class="line-container">
                <div class="point"></div>
                <div class="line"></div>
              </div>
              <div class="vision-text">
                <p class="title">我们的使命</p>
                <p>
                  通过领先的开发者孵化运营能力和产业<br />增长能力帮助开发者实现成功
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="md-vision hidden sm:block mb-[48px]" id="aboutVisoin">
        <div class="w-1440h-full">
          <div class="vision-content vision-content1 px-88 fade-in-up">
            <p class="section-title pt-80 mb-[32px] fade-in-up">愿景与使命</p>
            <div class="flex">
              <div class="line-container">
                <div class="point"></div>
                <div class="line h-[183px]"></div>
              </div>
              <div class="vision-text">
                <p class="title">我们的愿景</p>
                <p>中国领先的开发者孵化运营平台</p>
              </div>
            </div>
          </div>
          <div class="vision-content vision-content2 px-88 fade-in-up">
            <div class="flex pt-[32px]">
              <div class="line-container">
                <div class="point"></div>
                <div class="line h-[307px]"></div>
              </div>
              <div class="vision-text">
                <p class="title">我们的使命</p>
                <p>
                  通过领先的开发者孵化运营能力和产业<br />增长能力帮助开发者实现成功
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- <section class="manage md:hidden" id="aboutManage">
        <div class="w-1440 manage-nav">
          <div class="manage-nav-list">
            <div class="manage-swiper-button-prev"></div>
            <div
              v-for="(item, index) in manageData"
              :key="item.name"
              class="nav-item"
              :class="{ active: activeManageIndex === index }"
              @click="handleNavClick(index)"
            >
              <img class="icon" :src="item.img" alt="" />
            </div>
            <div class="manage-swiper-button-next"></div>
          </div>
        </div>
        <swiper
          class="swiper fade-in-up"
          ref="manageSwiper"
          :options="manageSwiperOptions"
        >
          <swiper-slide
            v-for="item in manageData"
            :key="item.name"
            class="swiperItem"
          >
            <div class="manage-content">
              <div class="w-1440 px-[78px] flex h-full">
                <div class="img-container">
                  <img class="img" :src="item.img" :alt="item.title" />
                </div>
                <div>
                  <p class="section-title">管理团队</p>
                  <div class="desc">
                    <p class="title">
                      {{ item.name }}<span>{{ item.title }}</span>
                    </p>
                    <div class="intro-list">
                      <div
                        class="list-item"
                        v-for="desc in item.intro"
                        :key="desc"
                      >
                        <p class="desc-text">{{ desc }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </section>
      <section class="md-manage hidden md:block relative" id="aboutManage">
        <p class="section-title pl-88 sm:!mb-[24px] fade-in-up">
          管理团队
        </p>
        <div class="w-1440 manage-nav">
          <div class="manage-nav-list px-88 sm:!top-[214px]">
            <div class="manage-swiper-button-prev"></div>
            <div class="manage-swiper-button-next"></div>
          </div>
        </div>
        <swiper
          class="swiper fade-in-up"
          ref="mdmanageSwiper"
          :options="manageSwiperOptions"
        >
          <swiper-slide
            v-for="item in manageData"
            :key="item.name"
            class="swiperItem"
          >
            <div class="h-[540px] sm:h-[342px] relative">
              <div class="img-container sm:!h-[301px]">
                <img
                  class="img sm:!h-[342px] sm:!w-[259px]"
                  :src="item.img"
                  :alt="item.title"
                />
              </div>
            </div>
            <div class="px-88 pt-[48px]">
              <div class="desc">
                <p class="title sm:!text-[24px]">
                  {{ item.name
                  }}<span class="sm:!text-[14px]">{{ item.title }}</span>
                </p>
                <div class="intro-list sm:!text-[12px]">
                  <div class="list-item" v-for="desc in item.intro" :key="desc">
                    <p class="desc-text">{{ desc }}</p>
                  </div>
                </div>
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </section> -->
      <div class="course">
        <Summary />
      </div>
      <section class="w-1440 relative" id="aboutPartner">
        <p class="section-title pl-88 pt-80 mb-[48px] sm:mb-[32px] fade-in-up">
          合作伙伴
        </p>
        <div
          class="partner px-88 pb-[80px] md:pb-[106px] sm:!pb-[72px] fade-in-up"
        >
          <div class="img-container">
            <img class="md:hidden" src="./assets/partner.png" alt="" />
            <img class="hidden md:block" src="./assets/partner-md.png" alt="" />
          </div>
          <div
            class="partner-bg w-[784px] h-[478px] md:w-[561px] md:h-[500px] sm:!w-[100%] sm:!h-[239px]"
          ></div>
        </div>
      </section>
    </main>
    <xmFooter></xmFooter>
  </div>
</template>

<script>
import xmHeader from "./../../components/xmHeader/xmHeader";
import xmFooter from "./../../components/xmFooter/xmFooter";
import Summary from "./../../components/Summary/index";
import sonNav from "./../../components/sonNav/pc.vue";
import utils from "utils/utils";

export default {
  name: "index",
  components: {
    xmHeader,
    xmFooter,
    Summary,
    sonNav,
  },

  data() {
    return {
      sonNavData: [
        {
          name: "关于小迈",
          id: "aboutIntro",
        },
        {
          name: "愿景与使命",
          id: "aboutVisoin",
        },
        // {
        //   name: "管理团队",
        //   id: "aboutManage",
        // },
        {
          name: "企业历程",
          id: "aboutCourse",
        },
        {
          name: "合作伙伴",
          id: "aboutPartner",
        },
      ],
      aboutIntroData: [
        { num: 11, unit: "年", des: "2015年至今成立" },
        { num: 4, unit: "城办公", des: "广州｜北京｜成都｜广西" },
        { num: 500, unit: "+伙伴", des: "富有激情｜敢闯敢拼｜勇于创新" },
        { num: "多", unit: "项荣誉", des: "未来独角兽｜拟上市百强｜高精尖企业" },
      ],
      manageData: [
        {
          name: "梁国盛",
          title: "创始人&CEO",
          intro: [
            "· 8年纳斯达克上市公司移动产品事业部总经理",
            "· 丰富的从零打造产品系列应用矩阵经验",
            "· 电子科技大学学士、中欧EMBA",
            "· 广州市创新创业领军人才",
            "· 人工智能与大数据专委会副主任委员",
            "· 广州市天河区第十届人大代表",
            "· 2021广东软件风云榜“新锐企业家”",
          ],
          img: require("./assets/梁老板.png"),
        },
        {
          name: "敖日明",
          title: "联合创始人&COO",
          intro: [
            "· 兼具高级工程师及产品项目总监经验",
            "· 曾服务于北电网络、久邦数码等知名企业",
            "· 天河区杰出优秀人才",
            "· 中山大学工学硕士",
          ],
          img: require("./assets/mark.png"),
        },
        {
          name: "刘恒",
          title: "联合创始人&CTO",
          intro: [
            "· 8年纳斯达克上市公司知名产品系列技术负责人",
            "· 丰富的应用矩阵技术经验",
            "· 武汉理工大学学士",
            "· 广州互联网协会第三届理事会常务理事",
          ],
          img: require("./assets/恒哥.png"),
        },
        {
          name: "孙爱华",
          title: "合伙人&CMO",
          intro: [
            "· 多年纳斯达克上市公司商务负责人",
            "· 百亿用户增长操盘手 · 实战派",
            "· 十余年聚焦移动互联网营销",
            "· 独创多种市场营销模式引领行业风向",
            "· 商业洞察敏锐度高、市场开拓能力极强",
            "· 中欧EMBA",
          ],
          img: require("./assets/aizong.png"),
        },
        {
          name: "吴瑩琳",
          title: "合伙人&财务副总裁",
          intro: [
            "· 国际四大会计师事务所工作背景",
            "· 历任广告媒体行业龙头企业、大型互联网金融科技公司财务总监",
            "· 超10年财务统筹管理及实操经验",
            "· 优秀的职业判断力及财务运筹能力",
            "· 丰富的资本运作及投融资经验",
          ],
          img: require("./assets/elaine.png"),
        },
      ],
      //核心优势
      activeManageIndex: 0,
      manageSwiperOptions: {
        direction: "horizontal",
        effect: "none",
        loop: false,
        autoplay: false,
        speed: 500,
        autoHeaight: true,
        // autoplayDisableOnInteraction: false,
        observer: true,
        on: {
          slideChange: () => {
            //控制幻灯片滑动的动画
            this.activeManageIndex = this.$refs.manageSwiper.swiper.realIndex;
          },
        },
        navigation: {
          nextEl: ".manage-swiper-button-next",
          prevEl: ".manage-swiper-button-prev",
        },
      },
    };
  },
  mounted() {
    utils.animateOnScroll(".fade-in-up");
  },
  methods: {
    handleNavClick(index) {
      this.activeManageIndex = index;
      this.$refs.manageSwiper.swiper.slideToLoop(index);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
